// third-party
import { configureStore } from '@reduxjs/toolkit';

// project imports
import rootReducer from './reducer';

// ==============================|| CREATE STORE FACTORY (for SSR) ||============================== //

/**
 * Creates a new Redux store instance for each request
 * This is necessary for SSR to avoid state leakage between requests
 */
export function createStore(preloadedState = {}) {
    return configureStore({
        reducer: rootReducer,
        preloadedState,
        middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false, immutableCheck: false })
    });
}

export default createStore;
